import { IDiemVanMinhApprovalRequest } from '../models/request/diemvanminh/IDiemVanMinhApprovalRequest';
import { IDiemVanMinhPublishRequest } from '../models/request/diemvanminh/IDiemVanMinhPublishRequest';
import { IDiemVanMinhSelectAvgRequest } from '../models/request/diemvanminh/IDiemVanMinhSelectAvgRequest';
import { IDiemVanMinhSelectRequest } from '../models/request/diemvanminh/IDiemVanMinhSelectRequest';
import { IDiemVanMinhKetQua } from '../models/response/diemvanminh/IDiemVanMinhKetQua';
import { apiClient } from './apiClient';
import { BaseCRUDApi } from './baseCRUDApi';
export const API_DIEM_VAN_MINH_KET_QUA_PATH = 'diemvanminh-ketqua'
export const API_DIEM_VAN_MINH_PHE_DUYET_PATH = 'diem-van-minh/phe-duyet'

class DiemVanMinhKetQuaApi extends BaseCRUDApi<IDiemVanMinhKetQua> {
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(path: string) {
        super(path);
    }
    Select(request: IDiemVanMinhSelectRequest) {
        return apiClient.post(`${API_DIEM_VAN_MINH_KET_QUA_PATH}/select`, request)
    }
    Inserts(request: any) {
        return apiClient.post(`${API_DIEM_VAN_MINH_KET_QUA_PATH}/inserts`, request)
    }
    Approve(request: IDiemVanMinhApprovalRequest) {
        return apiClient.put(`${API_DIEM_VAN_MINH_KET_QUA_PATH}/approve`, request)
    }
    Publish(request: IDiemVanMinhPublishRequest) {
        return apiClient.put(`${API_DIEM_VAN_MINH_KET_QUA_PATH}/send-notify`, request)
    }
    SelectAvgByMonths(request: IDiemVanMinhSelectAvgRequest) {
        return apiClient.post(`${API_DIEM_VAN_MINH_KET_QUA_PATH}/select-avg`, request)

    }

}
export const diemVanMinhKetQuaApi = new DiemVanMinhKetQuaApi(API_DIEM_VAN_MINH_KET_QUA_PATH)